export class ClonePaperReq {
    qnpId: number;
    language: number;

    constructor(qnpId: number,language: number) {
        this.qnpId = qnpId;
        this.language = language;
    }
}